import Dialog from '@/components/disalog.vue';
import Dialogteach from '@/components/Dialogteach.vue';
import VueQr from 'vue-qr'
export default {
  components: {
    Dialog,
    Dialogteach,
    VueQr
  },
  props: {
    message: {
      type: Object
    },
    mobile: {
      type: Number
    },
    downPwd: {
      type: String
    },
    url: {
      type: String
    },
    down_url: {
      type: String
    },
    token: {
      type: String
    },
    is_merge: {
      type: Number
    },
    down_url: {
      type: String
    }
  },

  data() {
    return {
      isShow: false, //显示举报弹窗
      isPassword: false, //显示下载密码
      // Android: '../assets/moban/General_Android.png',
      // Apple: '../assets/moban/General_Apple.png',
      // tipUrl: '../assets/wechat.png',
      // cipUrl: '../assets/qq.png',
      password: '', //下载密码
      id: '', //appid
      appName: '', //appname
      isTeach: false, //显示超级签名教程
      instaling: false, //显示安装中
      instalComplete: false, //显示安装描述文件
      downbut: true //显示下载按钮
    }
  },
  created() {
    if (this.downPwd == '' || this.downPwd == null || this.downPwd == 'null') {
      this.isPassword = false;
    } else {
      this.isPassword = true;
    }
    this.id = this.message.app_id;
    this.appName = this.message.in_name;
    if (this.message.template_language == 'zh-tw') {
      this.$i18n.locale = 'tw';
    } else if (this.message.template_language == 'en') {
      this.$i18n.locale = 'en';
    } else if (this.message.template_language == 'zh') {
      this.$i18n.locale = 'zh';
    }

  },
  computed: {
    pageWidth: function () {
      // console.log(window.screen.availWidth);
      return window.screen.availWidth;
    }
  },
  mounted() {
    document.title = this.appName;
  },
  methods: {
    submitPwd() {
      if (this.password == this.downPwd) {
        this.isPassword = false
      } else {
        this.$message.error(this.$t('lange.errcode'));
      }
    },
    ok() {
      this.isShow = false;
    },
    cancel() {
      this.isShow = false;
    },
    showDialog() {
      console.log("举报")
      this.isShow = true;
    },
    goto() {
      let host = document.domain;
      var temp = window.open('_blank')
      temp.location.href = "http://" + host + '/rule.html';
    },
    mianze() {
      this.$alert("<p style='padding-top:20px;link-height: 10px;'>平台为第三方应用提供应用反馈收集等服务。应用内容均来源于第三方产品，仅为用户提供下载支持，不涉及任何人工编辑和整理，也不对任何来源于第三方的内容（包括但不限于安装包安全、信息描述、应用截图）承担责任，用户可根据描述场景谨慎选择下载试用。</p><p style='padding-top:20px;link-height:10px;'>任何公司、产品或者个人认为平台涉嫌侵犯您的版权或应用权，您应该及时向我们提供举报声明、书面权利通知，并提供身份证明、权属证明及侵权情况等投诉材料。我们将依法进行处理。</p><p style='padding-top:20px;link-height: 10px;'>应用下载者与应用上传者如发生纠纷，请自行与上传者协商处理，协商无果请到相关部门进行投诉，或者拨打110警方介入，本平台不承担责任。</p>",
        '免责声明', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
          callback: action => {}
        });
    },
    downAndroid() {
      // console.log(this.down_url);
      // console.log(decodeURIComponent(this.down_url));
      this.downbut = false;
      var params = new URLSearchParams();
      params.append("token", this.token);
      this.$post(this.down_url, params).then((res) => {
        console.log(res)
        if (res.code == 200) {
          window.location.href = decodeURIComponent(res.data.downlink)
          this.instaling = true;
        } else {
          setTimeout(() => {
            this.downbut = true;
          }, 15000);
          this.$message.error(res.msg);
        }
      })

    },
    downIpa() {
      let that = this;
      this.downbut = false;
      // console.log(this.down_url);
      // console.log(decodeURIComponent(this.down_url));
      var params = new URLSearchParams();
      params.append("token", this.token);
      this.$post(this.down_url, params).then((res) => {
        if (res.code == 200) {
          window.location.href = decodeURIComponent(res.data.downlink)
          this.instaling = true;
          setTimeout(function () {
            that.instaling = false;
            if (that.message.in_type == 2) {
              that.instalComplete = true;
            }
          }, 5000)
        } else {
          setTimeout(() => {
            this.downbut = true;
          }, 15000);
          this.$message.error(res.msg);
        }
      })
    },
    downSuper() {
      let that = this;
      // console.log(this.down_url);
      // console.log(decodeURIComponent(this.down_url));
      window.location.href = decodeURIComponent(this.down_url);
      this.instaling = true;
      this.downbut = false;
      setTimeout(function () {
        that.instaling = false;
        that.instalComplete = true;
      }, 5000)
    },
    downDescribe() {
      window.location.href = decodeURIComponent(this.WindowApi.api + this.API.mobileprovision); //下载描述文件
    },
    opentech() {
      window.open(this.WindowApi.api + "/downapi/index/guide")
    },
    closeTeach() {
      this.isTeach = false;
    },
    timestampToTime2(timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return ''
      } else {
        var date = new Date(timestamp * 1000)
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
        var H = date.getHours() + ':'
        var M2 = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        var S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        return Y + M + D + H + M2 + S
      }
    }
  },

}



// WEBPACK FOOTER //
// ./src/mixins/mixin.js